<div class="w-100 my-1">
    <div class="multi-user-picker-container form-control" [class.disabled]="isReadonly() || !availableItems()?.length">
        @for (item of selectedItems(); track item[valueIdProp()]; let i = $index) {
            <span class="user-pill">
                <span class="user-pill-text">{{ item[displayNameProp()] }}</span>
                @if (!isReadonly()) {
                    <button type="button"
                            class="user-pill-remove"
                            (click)="removeContact(i)"
                            aria-label="Remove">
                        <i class="fa fa-times"></i>
                    </button>
                }
            </span>
        }
        @if (!isReadonly()) {
            <input (typeaheadOnSelect)="onValueSelected($event)"
                   [(ngModel)]="typeaheadFilter"
                   [typeaheadMinLength]="2"
                   [typeaheadOptionsLimit]="1000"
                   [typeaheadScrollable]="true"
                   [typeaheadWaitMs]="750"
                   [wsTypeahead]="typeaheadValues$"
                   autocomplete="off"
                   class="multi-user-picker-input"
                   container="body"
                   [placeholder]="selectedItems()?.length ? '' : placeholder()"
                   type="text"
                   [typeaheadOptionField]="displayNameProp()" />
        }
        @if (!availableItems()) {
            <ws-ace-loader [inline]="true"></ws-ace-loader>
        }
    </div>
</div>
